module.exports = __webpack_public_path__ + "static/FuturaBTMedium-a7715dc544921c0b4eee5373a0a3a10a.woff";